/**
 * Components: Cookie Pro
 * ------------------------------------------------------------------------------
 * A helper script for the Cookie Pro banner scripts.
 * - Exposes the OptanonWrapper function.
 *
 * @namespace cookiePro
 */

import log from 'salvo-lite/log'

class CookiePro {
    constructor (theme, elem) {
        log.debug(this.constructor.name, 'Constructed', this)
    }

    /**
   * Initiates the component.
   */
    onInit () {
        window.OptanonWrapper = () => {
            window.Optanon.OnConsentChanged(() => {
                window.Frame.EventBus.emit('SiteHeader:update')
                document.querySelector('.skip-link').blur()
            })

            document.querySelectorAll('a[href*="#cookies"]').forEach((element) => {
                element.addEventListener('click', (event) => {
                    event.preventDefault()
                    window.Optanon.ToggleInfoDisplay()
                })
            })
        }
    }

    /**
     * Expose public interface.
     */
    // return Object.freeze({
    //     init,
    // })
}

export default CookiePro



// WEBPACK FOOTER //
// ./src/resources/scripts/components/CookiePro.js